import React, { useRef, useState } from 'react'
import { MdExpandMore } from 'react-icons/md'

import { useClickOutside } from '../../../../hooks'

import styles from './template-selector.module.scss'

export const TemplateSelector = ({ onChange, templates = [] }) => {
  const [ isOpen, setOpen ] = useState(false)
  const wrapperRef = useRef(null)

  useClickOutside(wrapperRef, () => {
    setOpen(false)
  })

  return (
    <button
      className={styles.select}
      ref={wrapperRef}
      onClick={() => {
        setOpen((prev) => !prev)
      }}
    >
      <div className={styles.labelContainer}>
        <span className={styles.label}>Template</span>
        <MdExpandMore size='1.1rem' />
      </div>

      {isOpen && templates.length > 0 && (
        <div className={styles.itemList}>
          {templates.map(t => (
            <button
              key={t.id}
              type='button'
              className={styles.item}
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()

                onChange(t.id)
                setOpen(false)
              }}
            >
              {t.title}
            </button>
          ))}
        </div>
      )}
    </button>
  )
}
